import { MDSTextColor, MDSTextProps, MDSTextVariant } from "./text.types";
import { StyledText } from "./text.style";

const getDefaultElementForVariant = (variant: MDSTextVariant): keyof JSX.IntrinsicElements => {
  switch (variant) {
    case MDSTextVariant.HeaderXl:
    case MDSTextVariant.HeaderL:
      return "h1";
    case MDSTextVariant.HeaderM:
      return "h2";
    case MDSTextVariant.HeaderS:
      return "h3";
    case MDSTextVariant.ParagraphSm:
    case MDSTextVariant.ParagraphS:
      return "p";
    case MDSTextVariant.CodeSm:
      return "code";
    case MDSTextVariant.TextM:
    case MDSTextVariant.TextSm:
    case MDSTextVariant.TextS:
    case MDSTextVariant.TextXs:
    default:
      return "span";
  }
};

export const MDSText = ({
  children,
  variant = MDSTextVariant.TextS,
  weight,
  color = MDSTextColor.Primary,
  as,
  overflow,
  numberOfLines,
  onClick,
  ...rest
}: MDSTextProps) => {
  const elementType = as || getDefaultElementForVariant(variant);
  return (
    <StyledText
      as={elementType}
      $variant={variant}
      $weight={weight}
      $color={color}
      $overflow={overflow}
      $numberOfLines={numberOfLines}
      onClick={onClick}
      {...rest}
    >
      {children}
    </StyledText>
  );
};
